/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CloudCostMgmtAccountSummary } from './cloudCostMgmtAccountSummary';


/**
 * Paginated response for cloud cost management accounts
 */
export interface CloudCostMgmtAccountsPaginatedResponse { 
    /**
     * Current page size
     */
    current_page_size?: number;
    /**
     * Current page number
     */
    page_number?: number;
    /**
     * Requested page size
     */
    requested_page_size?: number;
    /**
     * Total number of pages
     */
    total_pages?: number;
    /**
     * Total number of records
     */
    total_record_count?: number;
    /**
     * List of account summaries
     */
    result: Array<CloudCostMgmtAccountSummary>;
}

